import { Directive } from '@angular/core';

@Directive({
  selector: '[appTutorialSlide]',
  host: {
    class: 'tutorial-slide',
    style:
      'flex: 0 0 100%; min-width: 0; height: 100%; display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden',
  },
})
export class TutorialWizardSlideDirective {}
